import { IResponseStatus, SignResultStatus } from '../services/report-workflow-exam.service';

export const isResponseSignOk = (result: IResponseStatus) => result.responseStatusType === SignResultStatus.Ok;

export const isResponseSignErrored = (result: IResponseStatus) => result.responseStatusType !== SignResultStatus.Ok;

export const isResponseSignLocked = (result: IResponseStatus) =>
    [SignResultStatus.Locked, SignResultStatus.Unlocked].includes(result.responseStatusType);

export const isResponseServerError = (result: IResponseStatus) =>
    [SignResultStatus.Failed, SignResultStatus.PdfGenerationFailed, SignResultStatus.P7mGenerationFailed].includes(
        result.responseStatusType,
    );

export const isExceptionCredentialFault = (result: IResponseStatus): boolean =>
    result.error?.message === 'Exception_CredentialsFault';
